import React, { createContext, useContext, useState, ReactNode } from "react";

// CreditContextの型定義
interface CreditContextType {
  drawerCreditTrigger: boolean;
  setCreditTrigger: (trigger: boolean) => void;
}

// コンテキスト作成
const CreditContext = createContext<CreditContextType | undefined>(undefined);

// Provider
export const CreditProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // クレジット更新トリガーの状態
  const [drawerCreditTrigger, setDrawerCreditTrigger] = useState(false);

  // トリガーの設定
  const setCreditTrigger = (trigger: boolean) => {
    setDrawerCreditTrigger(trigger);
  };

  // コンテキスト値
  const contextValue: CreditContextType = {
    drawerCreditTrigger,
    setCreditTrigger,
  };

  return <CreditContext.Provider value={contextValue}>{children}</CreditContext.Provider>;
};

// カスタムフック
export const useCreditContext = () => {
  const context = useContext(CreditContext);
  if (context === undefined) {
    throw new Error("useCreditContext must be used within a CreditProvider");
  }
  return context;
};
